module.exports = __webpack_public_path__ + "img/robot.4b2c2ce8.png";